"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnvironmentFeatureStates = exports.getEnvironmentFeatureState = exports.getIdentityFeatureStates = exports.getIdentityFeatureState = exports.OrganisationModel = exports.SegmentModel = exports.TraitModel = exports.IdentityModel = exports.FeatureStateModel = exports.EnvironmentModel = void 0;
var evaluators_1 = require("./segments/evaluators");
var errors_1 = require("./utils/errors");
var models_1 = require("./environments/models");
Object.defineProperty(exports, "EnvironmentModel", { enumerable: true, get: function () { return models_1.EnvironmentModel; } });
var models_2 = require("./features/models");
Object.defineProperty(exports, "FeatureStateModel", { enumerable: true, get: function () { return models_2.FeatureStateModel; } });
var models_3 = require("./identities/models");
Object.defineProperty(exports, "IdentityModel", { enumerable: true, get: function () { return models_3.IdentityModel; } });
var models_4 = require("./identities/traits/models");
Object.defineProperty(exports, "TraitModel", { enumerable: true, get: function () { return models_4.TraitModel; } });
var models_5 = require("./segments/models");
Object.defineProperty(exports, "SegmentModel", { enumerable: true, get: function () { return models_5.SegmentModel; } });
var models_6 = require("./organisations/models");
Object.defineProperty(exports, "OrganisationModel", { enumerable: true, get: function () { return models_6.OrganisationModel; } });
function getIdentityFeatureStatesDict(environment, identity, overrideTraits) {
    var e_1, _a, e_2, _b, e_3, _c, e_4, _d;
    // Get feature states from the environment
    var featureStates = {};
    try {
        for (var _e = __values(environment.featureStates), _f = _e.next(); !_f.done; _f = _e.next()) {
            var fs = _f.value;
            featureStates[fs.feature.id] = fs;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
        }
        finally { if (e_1) throw e_1.error; }
    }
    // Override with any feature states defined by matching segments
    var identitySegments = (0, evaluators_1.getIdentitySegments)(environment, identity, overrideTraits);
    try {
        for (var identitySegments_1 = __values(identitySegments), identitySegments_1_1 = identitySegments_1.next(); !identitySegments_1_1.done; identitySegments_1_1 = identitySegments_1.next()) {
            var matchingSegment = identitySegments_1_1.value;
            try {
                for (var _g = (e_3 = void 0, __values(matchingSegment.featureStates)), _h = _g.next(); !_h.done; _h = _g.next()) {
                    var featureState = _h.value;
                    if (featureStates[featureState.feature.id]) {
                        if (featureStates[featureState.feature.id].isHigherSegmentPriority(featureState)) {
                            continue;
                        }
                    }
                    featureStates[featureState.feature.id] = featureState;
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_h && !_h.done && (_c = _g.return)) _c.call(_g);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (identitySegments_1_1 && !identitySegments_1_1.done && (_b = identitySegments_1.return)) _b.call(identitySegments_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    try {
        // Override with any feature states defined directly the identity
        for (var _j = __values(identity.identityFeatures), _k = _j.next(); !_k.done; _k = _j.next()) {
            var fs = _k.value;
            if (featureStates[fs.feature.id]) {
                featureStates[fs.feature.id] = fs;
            }
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (_k && !_k.done && (_d = _j.return)) _d.call(_j);
        }
        finally { if (e_4) throw e_4.error; }
    }
    return featureStates;
}
function getIdentityFeatureState(environment, identity, featureName, overrideTraits) {
    var featureStates = getIdentityFeatureStatesDict(environment, identity, overrideTraits);
    var matchingFeature = Object.values(featureStates).filter(function (f) { return f.feature.name === featureName; });
    if (matchingFeature.length === 0) {
        throw new errors_1.FeatureStateNotFound('Feature State Not Found');
    }
    return matchingFeature[0];
}
exports.getIdentityFeatureState = getIdentityFeatureState;
function getIdentityFeatureStates(environment, identity, overrideTraits) {
    var featureStates = Object.values(getIdentityFeatureStatesDict(environment, identity, overrideTraits));
    if (environment.project.hideDisabledFlags) {
        return featureStates.filter(function (fs) { return !!fs.enabled; });
    }
    return featureStates;
}
exports.getIdentityFeatureStates = getIdentityFeatureStates;
function getEnvironmentFeatureState(environment, featureName) {
    var featuresStates = environment.featureStates.filter(function (f) { return f.feature.name === featureName; });
    if (featuresStates.length === 0) {
        throw new errors_1.FeatureStateNotFound('Feature State Not Found');
    }
    return featuresStates[0];
}
exports.getEnvironmentFeatureState = getEnvironmentFeatureState;
function getEnvironmentFeatureStates(environment) {
    if (environment.project.hideDisabledFlags) {
        return environment.featureStates.filter(function (fs) { return !!fs.enabled; });
    }
    return environment.featureStates;
}
exports.getEnvironmentFeatureStates = getEnvironmentFeatureStates;
